import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom'; 
 
import axios from 'axios'; 
import {api_base_url, base_url} from '../common/Constants';

 
class ContactContent extends React.Component{

    constructor(){
        super();

        
        this.state = { 
            loading : 1, 
            name:'',
            email:'',
            phone:'',
            message:'',
            errors:{},
            fopen:false,
            success_message:'',
            reg_error:false,
            err_message:"",
            sending:false
            
        }
        

    }

    handleSubmit = (event) => {
        event.preventDefault();
        const errors = {};
        if (!this.state.name) {
            errors.name = 'Name is required';
          }  
          if (!this.state.email || !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(this.state.email)) {
          errors.email = 'Invalid email';
        }
        
        if (!this.state.message) {
            errors.message = 'Message is required';
          } 
        if (Object.keys(errors).length > 0) {
          this.setState({ errors });
        } else {
            this.setState({sending:true});
             
            var data = {  name:this.state.name, 'email' :this.state.email, 'phone' :this.state.phone, 'message':this.state.message  }
            axios.post(api_base_url+"send_contact", data).then(response=>{

                if(response.data.error)
                {
                    this.setState({reg_error:true});
                    this.setState({fopen:false});
                    this.setState({err_message: response.data.message});  
                }
                else{
                    
                    this.setState({fopen:true});
                    this.setState({reg_error:false});
                    this.setState({success_message:" Enquiry Successfully Sent."});
                    this.setState({name:'',email:'', phone:'',message:'', sending:false});
                }
                
            }).catch((error) => { 
                  console.log('Conflict error:', error.response);
               
            });

        }
      };
    
    handleChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
      };

   

    render()
    { 
        
    return (
         
           <div>
            <div class="contact-area item-flex default-padding">
        <div class="container">
            <div class="row">
               <div class="col-md-6 contact-items">
        <div class="heading">
          <h3>Contact Details</h3>


          
          <ul id={this.props.settings.site_hide_head_office === "Yes" ? "dnone" : "dblock"}>
			<h4>Head Office</h4>
            <i class="fas fa-phone"></i> {this.props.settings.site_head_office_number}<br />
            <i class="fas fa-envelope"></i> {this.props.settings.site_email_address} <br/>
            <i class="fas fa-location-arrow"></i> {this.props.settings.site_head_office_address}
			  
          </ul>
			
			<ul>
			<h4>Factory</h4>
            <i class="fas fa-phone"></i> {this.props.settings.site_factory_number}<br />
            <i class="fas fa-envelope"></i> {this.props.settings.site_email_address} <br/>
            <i class="fas fa-location-arrow"></i> {this.props.settings.site_factory_address}
          </ul>
			<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d10286.178841552923!2d54.49287479769874!3d24.286738804518066!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5e40ecca173f57%3A0x817bb9bcfd12dc91!2sCool%20Pro!5e0!3m2!1sen!2sae!4v1743249974690!5m2!1sen!2sae" width="535" height="450"  
            
            allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
               
                <div class="col-md-6 contact-items">
                    <div class="heading">
                        <h2>Get Free Consultation</h2>
                        <p>
                            Get a free consultation from our experts, Our customer support team help you 24/7, Don’t hesitate.
                        </p>
                    </div>
                    <form action="" method="POST" class="contact-form">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="form-group">
                                    <input class="form-control" id="name" name="name" placeholder="Name" type="text" onChange={this.handleChange} value={this.state.name}  />
                                    <span class="alert-error">{this.state.errors.name && <label className="error">{this.state.errors.name}</label>}</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input class="form-control" id="email" name="email" placeholder="Email*" type="email"  onChange={this.handleChange} value={this.state.email}  />
                                    <span class="alert-error">{this.state.errors.email && <label className="error">{this.state.errors.email}</label>}</span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input class="form-control" id="phone" name="phone" placeholder="Phone" type="text"  onChange={this.handleChange} value={this.state.phone}  />
                                    <span class="alert-error">{this.state.errors.phone && <label className="error">{this.state.errors.phone}</label>}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <div class="form-group comments">
                                    <textarea class="form-control" id="message" name="message" placeholder="Tell Us About Project *"  onChange={this.handleChange} value={this.state.message} ></textarea>
                                    {this.state.errors.message && <label className="error">{this.state.errors.message}</label>}
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="row">
                                <button type="submit" name="submit" id="submit"   onClick={this.handleSubmit}>
                                    Send Message <i class="fa fa-paper-plane"></i>
                                </button>
                                <div id={this.state.sending ? "dblock" : "dnone"}> <img src={base_url+"assets/img/loader.gif"} className="Loader" alt="Loader" /></div>
                            </div>
                        </div>
                       
                        <div class="col-md-12 alert-notification">
                            <div id="message" class="alert-msg">
                                 
                            <div className='alert alert-success '  id={this.state.fopen ? "dblock" : "dnone"}>{this.state.success_message}</div>
                        
                        <div className='alert alert-warning '  id={this.state.reg_error ? "dblock" : "dnone"}>{this.state.err_message}</div>
    
                            </div>
                        </div>
                    </form>
                    
                </div>
               
            </div>
        </div>
    </div>
 
 

           </div>
            
    );
}

}

export default ContactContent;